import * as React from 'react';
import { useTheme } from '@/themes';
import { MainCobrandedLegalCopy } from './cancelled';
import { FullPageLayout } from '@/components/FullPageLayout';
import { ErrorPageTemplate, breakpoints } from '@zopauk/react-components';

const Error404 = () => {
  const { partnerName } = useTheme();

  return (
    <div className={partnerName === 'jl-money' ? 'co-branded' : undefined}>
      <FullPageLayout
        mainCobrandedLegalCopy={partnerName === 'jl-money' ? <MainCobrandedLegalCopy /> : null}
        isCobranded={partnerName === 'jl-money'}
        maxWidth={breakpoints.desktop}
      >
        <ErrorPageTemplate>
          <ErrorPageTemplate.Four0Four />
        </ErrorPageTemplate>
      </FullPageLayout>
    </div>
  );
};

export default Error404;
